import service from "@/api/service";
import { GetResponse } from "@/api/auto-stamp-cards/response";
import { GetRequest } from "@/api/auto-stamp-cards/request";

/**
 * スタンプカード自動付与店舗情報取得APIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/get-auto-stamp-cards", getRequest);
  return response.data as GetResponse;
}
